import React, { useEffect } from "react";
import Dashboard_buckets from "./dashboard_buckets/Dashboard_buckets";
import { Col, Row } from "react-bootstrap";
import ActiveApplications from "./activeApplications/ActiveApplications";
import WeeklyApplicationStatus from "./weeklyApplicationStatus/WeeklyApplicationStatus";
import ToDoTask from "./toDoTask/ToDoTask";
import ActiveUsers from "./activeUsers/ActiveUsers";
import InfoBanner from "./infoBanner/InfoBanner";

function Dashboard_Content() {
   
  return (
    <>
      <Row>
        <Col lg={12} className="mb-3">
          <Dashboard_buckets />
        </Col>

        <Col lg={8} className="mb-3">
          <ActiveApplications />
        </Col>

        <Col lg={4} className="mb-3">
          <WeeklyApplicationStatus />
        </Col>

        <Col lg={4} className="mb-3">
          <ToDoTask />
        </Col>

        <Col lg={8} className="mb-3">
          <ActiveUsers />
        </Col>

        <Col className="mb-3">
          <InfoBanner />
        </Col>
      </Row>
    </>
  );
}

export default Dashboard_Content;
